module.exports = __webpack_public_path__ + "img/tramite.1c76baa9.svg";